import { render } from "./chatRoom.vue?vue&type=template&id=631d6151&scoped=true"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"

import "./chatRoom.vue?vue&type=style&index=0&id=631d6151&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631d6151"]])

export default __exports__